module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.themeClasses
  }, [_c('div', {
    staticClass: "alp-theme__header"
  }, [_c('alp-big-theme', {
    attrs: {
      "image": _vm.theme.slug
    }
  }, [_vm._v(_vm._s(_vm.title))])], 1), _vm._v(" "), (_vm.isWriting) ? _c('div', {
    staticClass: "alp-theme__writing"
  }, [_c('h2', [_vm._v("Thème en cours de rédaction")]), _vm._v(" "), _c('p', {
    staticClass: "alp-theme__intro"
  }, [_vm._v("\n      Ce thème est actuellement en cours de rédaction.\n    ")])]) : _vm._e(), _vm._v(" "), (!_vm.isWriting) ? _c('p', {
    staticClass: "alp-theme__intro",
    domProps: {
      "innerHTML": _vm._s(_vm.intro)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.theme.relatives && !_vm.isWriting) ? _c('div', {
    staticClass: "alp-theme__sublinks"
  }, [_c('div', {
    staticClass: "alp-theme__sublinks__buttons"
  }, _vm._l((_vm.theme.relatives), function(rel) {
    return _c('alp-button', {
      key: "rel.link",
      attrs: {
        "blue": rel.title === _vm.theme.title,
        "shadow": true,
        "link": rel.link
      }
    }, [_vm._v(_vm._s(rel.title))])
  }))]) : _vm._e(), _vm._v(" "), (!_vm.isWriting) ? _c('div', {
    staticClass: "alp-theme__fn"
  }, [_c('alp-card', [_c('h2', {
    staticClass: "alp-theme__fn__title"
  }, [_vm._v("\n        Quelques propositions du\n        "), _c('span', {
    staticClass: "alp-theme__fn__title__blue"
  }, [_vm._v("Front National")])]), _vm._v(" "), _c('p', {
    staticClass: "alp-theme__fn__proposals",
    domProps: {
      "innerHTML": _vm._s(_vm.theme.fn)
    }
  })])], 1) : _vm._e(), _vm._v(" "), (!_vm.isWriting) ? _c('div', {
    staticClass: "alp-theme__fi"
  }, [_c('alp-card', {
    attrs: {
      "background": "blue"
    }
  }, [_c('h2', {
    staticClass: "alp-theme__fi__title"
  }, [_vm._v("\n        L'analyse de la France Insoumise\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "alp-theme__fi__proposals",
    domProps: {
      "innerHTML": _vm._s(_vm.theme.fi)
    }
  }), _vm._v(" "), (_vm.theme.badge) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.theme.badge) ? _c('strong', [_vm._v("Conclusion : "), _c('alp-tag', {
    attrs: {
      "theme": _vm.theme.badge.color
    }
  }, [_vm._v(_vm._s(_vm.theme.badge.text))])], 1) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (!_vm.isWriting) ? _c('div', {
    staticClass: "alp-theme__fi-proposals"
  }, [_c('h2', {
    staticClass: "alp-theme__fi-proposals__title"
  }, [_vm._v("Les propositions de l’Avenir en Commun")]), _vm._v(" "), _c('img', {
    staticClass: "alp-theme__fi__aec",
    attrs: {
      "src": require("./assets/aec.png"),
      "alt": "Ce qu'en dit l'Avenir en Commun",
      "height": "160",
      "width": "160"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "alp-theme__fi-proposals__proposal",
    domProps: {
      "innerHTML": _vm._s(_vm.theme.aec)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "alp-theme__more"
  }, [_c('h2', {
    staticClass: "alp-theme__more__title"
  }, [_vm._v("Envie d'en savoir plus ?")]), _vm._v(" "), _c('div', {
    staticClass: "alp-theme__more__buttons"
  }, [_c('alp-button', {
    attrs: {
      "href": "https://laec.fr"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n          Consulter"), _c('br'), _vm._v("\n          L'Avenir en Commun\n        ")])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b611d9f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Theme.vue
// module id = 183
// module chunks = 0